module.exports = __webpack_public_path__ + "static/img/3_v2.bbae1c16.png";